// extracted by mini-css-extract-plugin
export default {"measuresLabel":"MeasuresListView_measuresLabel__1AUWy"};